var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowsMaximize2Glyph16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 0h-5a1 1 0 000 2h2.586L9.293 5.293a1 1 0 101.414 1.414L14 3.414V6a1 1 0 002 0V1a1 1 0 00-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    d: "M6.707 9.293a1 1 0 00-1.414 0L2 12.586V10a1 1 0 00-2 0v5a1 1 0 001 1h5a1 1 0 000-2H3.414l3.293-3.293a1 1 0 000-1.414z"
  }))));
}

export default SvgArrowsMaximize2Glyph16;